import React from 'react';
import { CardTW } from 'tailwindComponents/CardTW/CardTW';
import { IEscrowExpectedIncomingAchData } from 'types/accounting/data/IEscrowExpectedIncomingAchData';
import { IPageData } from 'types/rest/IPageData';
import { IPotentialMatch } from './IPotentialMatch';
import { ExpectedDisplay } from './ExpectedDisplay';

export interface IExpectedACHTableDisplayProps {
  data: IPageData<IEscrowExpectedIncomingAchData>;
  accountNumber: string;
  setPotentialMatch: (x: IPotentialMatch) => void;
}

export const ExpectedACHTableDisplay: React.FC<IExpectedACHTableDisplayProps> = ({
  data,
  setPotentialMatch,
  accountNumber,
}) => {
  return (
    <CardTW
      title={
        <>
          Orders Expecting ACHs
          {data && (
            <span className="ml-8 rounded-full bg-green-100 px-2 py-1 align-middle text-xs font-medium text-green-700">
              {data.content.length} Item{data.content.length === 1 ? '' : 's'}
            </span>
          )}
        </>
      }
      isCollapsible
      isCollapsed
      contentClassName={'px-0'}
    >
      <div>
        {data.content.map((expectedACH) => (
          <ExpectedDisplay
            key={expectedACH.id}
            expected={expectedACH}
            actionLabel={'Match'}
            accountNumber={accountNumber}
            onAction={() => setPotentialMatch({ expectedACH })}
          />
        ))}
      </div>
    </CardTW>
  );
};
